import { supabase } from '../lib/supabase.js';
import { getState, setState } from '../state/store.js';

async function loadProfile(userId) {
  const { data, error } = await supabase
    .from('profiles')
    .select('id, full_name, role')
    .eq('id', userId)
    .single();
  if (error) {
    console.error('Failed to load profile', error);
    return null;
  }
  return data;
}

async function applySession(session) {
  if (!session) {
    setState({ authStatus: 'signed_out', session: null, profile: null, sites: [], sitesLoaded: false, recentTransactions: [] });
    return;
  }
  const profile = await loadProfile(session.user.id);
  setState({ authStatus: 'signed_in', session, profile });
}

export function initAuth() {
  supabase.auth.getSession().then(({ data }) => applySession(data.session));
  supabase.auth.onAuthStateChange((_event, session) => {
    applySession(session);
  });
}

export async function login(email, password) {
  const { error } = await supabase.auth.signInWithPassword({ email, password });
  if (error) return { ok: false, message: error.message };
  return { ok: true };
}

export async function logout() {
  await supabase.auth.signOut();
}

export function renderLoginScreen() {
  const wrap = document.createElement('div');
  wrap.className = 'loginScreen';
  wrap.innerHTML = `
    <div class="loginCard">
      <div class="loginBrand">AFIT<span>EXP</span><small>SITE EXPENSE &amp; P&amp;L</small></div>
      <form id="loginForm" class="loginForm">
        <label>Email<input id="loginEmail" type="email" autocomplete="username" required></label>
        <label>Password<input id="loginPassword" type="password" autocomplete="current-password" required></label>
        <div id="loginError" class="loginError" hidden></div>
        <button class="wideBtn" type="submit">Log In</button>
      </form>
    </div>
  `;

  const form = wrap.querySelector('#loginForm');
  const errorBox = wrap.querySelector('#loginError');
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errorBox.hidden = true;
    const submitBtn = form.querySelector('button[type="submit"]');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Logging in…';
    const email = wrap.querySelector('#loginEmail').value.trim();
    const password = wrap.querySelector('#loginPassword').value;
    const result = await login(email, password);
    if (!result.ok) {
      errorBox.textContent = result.message || 'Login failed';
      errorBox.hidden = false;
      submitBtn.disabled = false;
      submitBtn.textContent = 'Log In';
    }
    // On success, onAuthStateChange fires and main.js re-renders the app shell.
  });

  return wrap;
}
